import { render, staticRenderFns } from "./GoodslistModal.vue?vue&type=template&id=0975df38&scoped=true&"
import script from "./GoodslistModal.vue?vue&type=script&lang=js&"
export * from "./GoodslistModal.vue?vue&type=script&lang=js&"
import style0 from "./GoodslistModal.vue?vue&type=style&index=0&id=0975df38&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0975df38",
  null
  
)

export default component.exports